var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"imgbox"},[_c('div',{staticClass:"info"},[_c('p',{staticClass:"p1"},[_vm._v("欢迎")]),_vm._v(" "),_c('p',{staticClass:"p2"},[_vm._v("财富之路，进无止境")]),_vm._v(" "),_c('p',{staticClass:"p3"},[_vm._v("登录信源微信商城")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cf6b4d1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/indexForStore.vue
// module id = S49U
// module chunks = 118